import React from "react";

const SkillsView = () => {
  return <>Skills</>;
};

export default SkillsView;